import * as React from 'react';
import { Button } from 'components/base';

type Props = {
    selectHandler: (id: number | string) => void;
    id: number | string;
    name: string;
    price: number;
    currency: string;
    navigateToCompanySignup: () => void;
    categories: string[];
};

const ProductItem: React.FC<Props> = ({
    selectHandler,
    id,
    name,
    price,
    currency = 'NOK',
    navigateToCompanySignup,
    categories,
}: Props) => {
    const onProductSelect = () => {
        for (let i = 0; i < categories.length; i++) {
            const category = categories[i];
            category.toLocaleLowerCase().includes('proff') &&
                navigateToCompanySignup();
        }
        selectHandler(id);
    };

    const productName = name.toLowerCase().includes('årlig')
        ? currency === 'NOK'
            ? 'Betal Årlig'
            : 'Pay Yearly'
        : currency === 'NOK'
        ? 'Betal Månedlig'
        : 'Pay Monthly';

    return (
        <Button
            fullWidth
            style={{
                border: name.toLowerCase().includes('månedlig')
                    ? '1px solid var(--primaryColor)'
                    : 'none',
                borderRadius: '8px',
            }}
            sx={{
                maxWidth: '400px',
                minWidth: '311px',
                marginBottom: '16px',
                textTransform: 'uppercase',
            }}
            subtitle={
                currency.toLowerCase() === 'usd'
                    ? '$' + price
                    : price + '.- ' + currency
            }
            appearance={name.toLowerCase().includes('årlig') ? 'cta' : 'text'}
            onClick={onProductSelect}
        >
            {productName}
        </Button>
    );
};

export default ProductItem;
